import React, { useEffect, useState } from 'react'
import PageLoader from 'Lib/Pageloader'

import { httpAxios, fireClevertapEvent } from 'AccountsUtils'
import { CASE_HISTORY_MODAL_DETAIL, POST_CALL } from 'AccountsConstants/api_endpoints'

import RaiseComplaintModal from './RaiseComplaintModal'

import './RaiseComplaintModal.css'

const EscalationsModal = props => {
  const {
    complaintInput,
    showComplaintError,
    validateComplaint,
    message,
    isDirty,
    setIsDirty
  } = props
  useEffect(() => {
    setIsDirty(false)
  }, [])
  return (
    <React.Fragment>
      <div>{message}</div>
      <div className="flex flex-center amt-10 mt10 pb-2">
        <textarea
          placeholder=""
          rows={6}
          className={`${showComplaintError ? 'input-complaint error-input' : 'input-complaint'}`}
          onInput={e => validateComplaint(e.target.value)}
        >
          {complaintInput}
        </textarea>
      </div>
      {complaintInput === '' && isDirty && (
        <div className={showComplaintError ? 'error-message apr-20 pb-2' : 'error-message o-0'}>
          Please provide additional details for us to act on it.
        </div>
      )}
    </React.Fragment>
  )
}

const RaiseComplaintAction = props => {
  const {
    header,
    type,
    complaintToggle,
    modalContent,
    setComplaintToggle,
    setRefetchCases,
    callId,
    tripId,
    setHeader,
    setModalContent,
    setCallBackType,
    setDisableBg,
    isPWA
  } = props

  // const [showInputError, updateInputErrorFlag] = useState(false)
  const [showComplaintError, updateComplaintError] = useState(false)
  const [complaintInput, setComplaint] = useState('')
  const [complaintFlag, setComplaintFlag] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    setIsDirty(false)
    setComplaint('')
    updateComplaintError(false)
  }, [complaintToggle])

  useEffect(() => {
    if (type === 'complaint') {
      fireClevertapEvent('raise_complaint_shown', { trip_id: tripId })
    } else {
      fireClevertapEvent('Request_escalated_pop_up_shown', { trip_id: tripId })
    }
  }, [])

  const FulfillmentModal = ({ message }) => (
    <React.Fragment>
      <div className="amb-15 mb15 fs-13 h-13">{message}</div>
    </React.Fragment>
  )

  const validateComplaint = val => {
    setIsDirty(true)
    setComplaint(val)
    if (val) {
      updateComplaintError(false)
    } else {
      updateComplaintError(true)
    }
  }

  const primaryButtonConfig = {
    visible: true,
    text: 'Submit',
    action: (options, requestData, inputType) => {
      setIsDirty(complaintInput.length === 0)
      const payload = {
        callId,
        complaint: complaintInput,
        type
      }
      if (complaintInput !== '') {
        setLoader(true)
        httpAxios(CASE_HISTORY_MODAL_DETAIL + tripId, POST_CALL, payload)
          .then(resp => {
            setLoader(false)
            setComplaintFlag(true)
            fireClevertapEvent('raise_complaint_submit_clicked', { trip_id: tripId })
            setHeader(resp.data.header)
            setModalContent(resp.data.message)
            setCallBackType(resp.data.type)
          })
          .catch(() => {
            setComplaint('')
            setDisableBg(false)
            setLoader(false)
            setIsDirty(false)
            updateComplaintError(false)
            setComplaintToggle(false)
          })
      } else {
        updateComplaintError(true)
      }
      setComplaint('')
    }
  }
  const secondaryButtonConfig = {
    visible: true,
    text: 'Cancel',
    action: () => {
      fireClevertapEvent('raise_complaint_cancel_clicked', { trip_id: tripId })
      setComplaint('')
      setIsDirty(false)
      setDisableBg(false)
      updateComplaintError(false)
      setComplaintToggle(false)
    }
  }
  const successButtonConfig = {
    visible: true,
    text: 'Okay, got it',
    action: () => {
      if (complaintFlag) {
        fireClevertapEvent('My_issue_is_not_resolved_submit_clicked', { trip_id: tripId })
      } else {
        fireClevertapEvent('I_need_urgent_help_submit_clicked', { trip_id: tripId })
      }
      setComplaint('')
      setComplaintFlag(false)
      setDisableBg(false)
      setIsDirty(false)
      updateComplaintError(false)
      setComplaintToggle(false)
      setRefetchCases(true)
    }
  }

  return (
    <div>
      <If condition={loader}>
        <PageLoader
          title="Please wait"
          message="While we are processing."
          className={`${isPWA ? '' : 'modal-loader'}`}
        />
        <Else />
        <If condition={complaintToggle && type === 'complaint'}>
          <div className="modal-outer">
            <RaiseComplaintModal
              content={(
                <EscalationsModal
                  complaintInput={complaintInput || ''}
                  showComplaintError={showComplaintError}
                  validateComplaint={validateComplaint}
                  message={modalContent}
                  isDirty={isDirty}
                  setIsDirty={setIsDirty}
                />
              )}
              primaryButton={primaryButtonConfig}
              secondaryButton={secondaryButtonConfig}
              header={header}
              type={type}
            />
          </div>
        </If>

        <If condition={complaintToggle && (type === 'fulfillment' || type === 'support')}>
          <div className="modal-outer">
            <RaiseComplaintModal
              content={<FulfillmentModal message={modalContent} />}
              successButton={successButtonConfig}
              header={header}
              type={type}
            />
          </div>
        </If>
      </If>
    </div>
  )
}

export default RaiseComplaintAction
